module.exports = __webpack_public_path__ + "static/media/ks_shack_kayak_highlight.f9a15bbe.svg";